







































































import {Vue, Component} from 'vue-property-decorator';
import ClickOutside from 'vue-click-outside';
import Footers from '@/components/Footers.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import Logo from '@/components/common/Logo.vue';

@Component({
  components: { Logo, Footers, CompSelectBox},
  directives: {ClickOutside}
})
export default class AdminPasswordByKey extends Vue {
  private key: string = '';
  private email: string = '';
  private mustFlg: boolean = false;
  // 새 비밀번호
  private newPassword = '';
  private newPasswordGuides = '';
  private focusNewPwd() {
    this.newPasswordGuides = 'guide';
  }

  created() {
    if (this.$route.query.key) {
      this.key = this.$route.query.key as string;
    }
    if (this.$route.query.email) {
      this.email = this.$route.query.email as string;
    }
  }

  private checkNewPwd() {
    this.newPasswordGuides = '';
    if (this.newPassword.length < 8) {
      this.newPasswordGuides = 'err_length';
    } else {
      let result = this.validatePassword();
      if (result !== 'SUCCESS') {
        this.newPasswordGuides = result;
      }
    }

    if (this.newPasswordConfirm.length > 0) {
      this.changeNewPwdCfm();
    }
  }

  // 새 비밀번호 확인
  private newPasswordConfirm = '';
  private newPasswordConfirmGuides = '';
  private focusNewPwdCfm() {
    if (this.newPasswordConfirmGuides !== 'pass' && this.newPasswordConfirmGuides !== 'fail') {
      this.newPasswordConfirmGuides = 'guide';
    }
  }
  private changeNewPwdCfm() {
    this.newPasswordConfirmGuides = '';
    if (this.newPassword.length > 0 && this.newPassword === this.newPasswordConfirm) {
      this.newPasswordConfirmGuides = 'pass';
    } else {
      this.newPasswordConfirmGuides = 'fail';
    }
  }

  // 메인으로 이동
  private goToMain() {
    // (임시-추후 복원)레거시 로그인 페이지로 이동을 위해
    this.$router.replace('/login');
    // window.location.href = '/login';
  }
  // 비밀번호 변경
  private changePwd() {
    if (this.checkAll()) {
      let request = {
        data: {
          newPassword: this.newPassword,
          email: this.email,
          key: this.key,
          adminType: 'SERVICE'
        }
      };

      this.$api
        .putAdminsPasswordByKey(request)
        .then(() => {
          alert(this.$t('PASSWORD_CHANGE_SUCCESS_MSG'));
          this.goToMain();
        })
        .catch((error: any) => {
          this.newPassword = '';
          this.newPasswordGuides = '';
          this.newPasswordConfirm = '';
          this.newPasswordConfirmGuides = '';
          alert(error.data.message || this.$t('VIEW_LOGIN_ADMIN_ERROR'));
        });
    }
  }
  private checkAll() {
    if (this.newPassword.length === 0) {
      alert(this.$t('PASSWORD_CHANGE_ERR_NEW_PWD_EMPYT'));
      return false;
    }
    if (this.newPasswordConfirm.length === 0) {
      alert(this.$t('PASSWORD_CHANGE_ERR_NEW_PWD_CONFIRM_EMPYT'));
      return false;
    }
    if (!this.mustFlg && this.newPasswordGuides === 'err_length') {
      alert(this.$t('PASSWORD_CHANGE_ERR_NEW_PWD_LENGTH2'));
      return false;
    }
    if (this.newPasswordConfirmGuides === 'fail') {
      alert(this.$t('PASSWORD_CHANGE_NEW_PWD_CONFIRM_GUID'));
      return false;
    }
    if (this.mustFlg && this.newPassword.length < 8) {
      alert(this.$t('PASSWORD_CHANGE_ERR_NEW_PWD_LENGTH'));
      return false;
    }
    let result = this.validatePassword();
    if (result !== 'SUCCESS') {
      if (result === 'not_allow_special') {
        alert(this.$t('PASSWORD_CHANGE_NEW_PWD_ERR_4'));
      } else if (result === 'complexity_at_least3') {
        alert(this.$t('PASSWORD_CHANGE_NEW_PWD_ERR_3'));
      } else if (result === 'complexity_at_least2') {
        alert(this.$t('PASSWORD_CHANGE_NEW_PWD_ERR_2'));
      }
      return false;
    }
    return true;
  }

  private validatePassword() {
    const patternNumber = /[0-9]/g;
    const patternEnglish = /[a-zA-Z]/gi;
    const patternSpecial = /[!@#$%^&+=\-_.()]/g;

    const checkNumber = patternNumber.test(this.newPassword) ? 1 : 0;
    const checkEnglish = patternEnglish.test(this.newPassword) ? 1 : 0;
    const checkSpecial = patternSpecial.test(this.newPassword) ? 1 : 0;
    const checkSum = checkNumber + checkEnglish + checkSpecial;

    const filteringPassword = this.newPassword.replace(patternNumber, '').replace(patternEnglish, '').replace(patternSpecial, '');

    let result = 'SUCCESS';
    if (filteringPassword.length > 0) {
      result = 'not_allow_special';
    } else {
      if (this.newPassword.length < 10) {
        if (checkSum < 3) {
          result = 'complexity_at_least3';
        }
      } else if (checkSum < 2) {
        result = 'complexity_at_least2';
      }
    }

    return result;
  }
}
